import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { API } from 'api';
import { LatLng } from 'shared/types';
import { WaterLevel } from '../../waterLevel.types';

type UseWaterLevelProps = {
  id?: number;
};

type UseWaterLevel = Omit<UseQueryResult<WaterLevel, Error>, 'data'> & {
  waterLevel?: WaterLevel;
};

export type ServerWaterLevel = {
  id: WaterLevel['id'];
  name: WaterLevel['name'];
  data: {
    usgsId: WaterLevel['usgsId'];
    noaaLid: WaterLevel['noaaLid'];
    floodCategories: WaterLevel['floodCategories'];
    floodImpacts: WaterLevel['floodImpacts'];
  };
  units: WaterLevel['units'];
  location: LatLng;
  isOffline: boolean;
};

const fetchWaterLevel = async (
  waterLevelId: number | string,
): Promise<WaterLevel> => {
  const response = await API.get<ServerWaterLevel>(
    `weather/station/${waterLevelId}/`,
  );

  const { data, ...serverWaterLevelRoot } = response.data;

  return {
    ...serverWaterLevelRoot,
    ...data,
  };
};

export const useWaterLevel = (props: UseWaterLevelProps): UseWaterLevel => {
  const { id } = props;

  const { data, ...results } = useQuery({
    queryKey: ['waterLevel', id],
    queryFn: () => fetchWaterLevel(id!),
    enabled: Boolean(id),
  });

  return {
    ...results,
    waterLevel: data,
  };
};
